const cockpit = [{
  path: '/announcement',
  name: 'announcement',
  component: () => import('@/views/announcement'),
  meta: {
    title: '公告管理'
  }
}, {
  path: '/announcement/significanceInform',
  name: 'announcement/significanceInform',
  component: () => import('@/views/announcement/significanceInform'),
  meta: {
    title: '重要通知列表'
  }
}, {
  path: '/announcement/commonExamine',
  name: 'announcement/commonExamine',
  component: () => import('@/views/announcement/commonExamine'),
  meta: {
    title: '公告查看'
  }
}]

export default cockpit



// WEBPACK FOOTER //
// ./src/router/setting/announcement.js